import { useEffect } from 'react'

interface UseAPIInitializationProps {
  projectId: number | null
  urlProjectId: string | undefined
  setCurrentProjectId: (id: number | null) => void
  setSiteProjectId: (id: number | null) => void
  loadTypes: () => Promise<void>
}

/**
 * Hook to initialize API-related data when project changes.
 * Sets the current project ID (mapId) and site project ID, then loads object types.
 */
export function useAPIInitialization({
  projectId,
  urlProjectId,
  setCurrentProjectId,
  setSiteProjectId,
  loadTypes,
}: UseAPIInitializationProps): void {
  useEffect(() => {
    if (projectId && urlProjectId) {

      // Set current project ID to lot/map ID for object type APIs
      setCurrentProjectId(projectId)

      // Set site project ID for file storage paths
      const siteId = parseInt(urlProjectId, 10)
      setSiteProjectId(isNaN(siteId) ? null : siteId)

      // Load object types from API
      loadTypes().catch((error) => {
      })
    } else {
      // Clear project IDs when no project selected
      setCurrentProjectId(null)
      setSiteProjectId(null)
    }
  }, [projectId, urlProjectId, setCurrentProjectId, setSiteProjectId, loadTypes])
}
